import React from "react";
import { Link } from "react-router-dom";

const SidebarHeader: React.FC = () => {
  return (
    <div className="flex items-center justify-between gap-3 border-b border-white/10">
      
      <Link to="/" className="flex items-center">
        <img
          src="/assets/logo/LogoBrainCreaWhite.png"
          alt="Braincrea"
          className="h-16 w-auto object-contain drop-shadow-[0_4px_8px_rgba(0,0,0,0.3)] transition-all duration-300 hover:drop-shadow-[0_4px_12px_rgba(22,241,158,0.4)]"
        />
      </Link>

    </div>
  );
};

export default SidebarHeader;